import Vuex from 'vuex'
import Vue from 'vue'
import largeSidebar from './modules/largeSidebar'
import compactSidebar from './modules/compactSidebar'
import themeConfig from './modules/themeConfig'
import verticalSidebar from './modules/verticalSidebar'
import clients from './modules/admnistration/clients'
import invoice from './modules/invoices/invoice'
import authentication from './modules/sessions/authentication'
import statistics from './modules/dashboard/statistics'
import users from './modules/admnistration/users'
import credentialsTef from './modules/admnistration/credentialsTef'
import folios from '@/store/modules/invoices/folios'
import certificates from '@/store/modules/invoices/certificates'
import numerations from './modules/admnistration/numerations'
import emisor from './modules/admnistration/emisor'
import billingDate from '@/store/modules/invoices/billingDate'
import tradeName from '@/store/modules/invoices/tradeName'
import contingencyAuto from '@/store/modules/invoices/contingencyAuto'
import activarDEE from '@/store/modules/invoices/activarDEE'
import activarTicket from '@/store/modules/invoices/activarTicket'
import addressOptional from '@/store/modules/invoices/addressOptional'
import emailOptional from '@/store/modules/invoices/emailOptional'
import maxInvoiceAmount from '@/store/modules/invoices/maxInvoiceAmount'

import ui from './modules/ui'
import loyaltyPuntosColombia from '@/store/modules/admnistration/loyaltyPuntosColombia'
import alianzas from '@/store/modules/admnistration/alianzas'
// Load Vuex
Vue.use(Vuex)

// Create store
export default new Vuex.Store({
  modules: {
    ui,
    largeSidebar,
    compactSidebar,
    themeConfig,
    invoice,
    verticalSidebar,
    clients,
    emisor,
    numerations,
    authentication,
    statistics,
    users,
    credentialsTef,
    folios,
    certificates,
    billingDate,
    tradeName,
    contingencyAuto,
    activarDEE,
    activarTicket,
    addressOptional,
    emailOptional,
    maxInvoiceAmount,
    loyaltyPuntosColombia,
    alianzas,

  },
})
